<template>
  <div
    v-loading="loadHistory"
    class="cousreing_box cousreing_next de_cousreing_box"
    style="background: #ECF0F3;"
  >
    <div
      class="cousre_header"
      style="margin: 25px 0;background: #ECF0F3;box-shadow: 0px 12px 35px 0px rgba(136, 160, 194, 0.16);height: 46px;line-height: 46px;"
    >
      <!-- <el-radio-group v-model="selectType" size="small">
        <el-radio-button v-for="(item,index) in selectTypeList" :label="item['value']" :key="index">
          {{item['name']}}
        </el-radio-button>
      </el-radio-group> -->
      <template v-for="item in selectTypeList">
        <span
          :style="'position: relative;padding: 0px 10px;font-weight: 500;color: rgb(144, 147, 153);cursor: pointer;height: 100%;display: inline-block;font-size: 16px;'+(panelType == item['value']?'border-bottom: solid #0046AA;color: #0046AA;':'')"
          @click="doShowHistorySyncResult(item['value'])"
        >
          {{ item['name'] }}
          <span
            v-if="item['isDeploy']"
            style="position: absolute;top: -25%;color:#f56c6c;"
          >•</span>
        </span>
      </template>
    </div>
    <div
      class="cousre_header"
      style="margin: 10px 0;text-align: left;padding-left: 25px;font-size: 16px;line-height: 21px;"
    >
      <slot name="cousreTitle" />&nbsp;&nbsp;<em>{{ courseHistory.length }}</em>
      <button
        class="button_E330 buttonRefresh"
        :class="!isDoCardsetResresh?'button_eventNone_E330':''"
        @click="cardsetResresh"
      >
        {{ $t('devicecard.refresh') }}&nbsp;<i :class="!isDoCardsetResresh?'el-icon-time':'el-icon-refresh'" />
      </button>
    </div>
    <!-- <i class="el-icon-close text-button" @click="close"></i> -->
    <div
      class="course_prcess"
      style="height:calc( 100% - 210px);background: #FDFDFE;"
    >
      <vuescroll>
        <div
          v-for="(item, index) in courseHistory"
          :key="item.index"
        >
          <div
            v-if="item.ResultCode !== 1"
            class="course_list"
          >
            <div>
              <div class="course_cont course_container">
                <!-- <span class="prcess_index" v-html="index + 1 + '.<br>' + (item.TransType?(typeTranslate[item.TransType+''] || ''):'')"></span> -->
                <span class="prcess_index">{{ index + 1 }}
                  <!--  <br>
            <template v-if="panelType == 3">
              <template v-if="item.IFtttType == 1">{{typeTranslate['2']}}</template>
              <template v-else-if="item.IFtttType == 5">{{typeTranslate['9']}}</template>
              <template v-else-if="item.IFtttType == 6">{{typeTranslate['10']}}</template>
            </template>
            <template v-else>
              {{(item.TransType?(typeTranslate[item.TransType+''] || ''):'')}}
            </template> -->
                </span>
                <div class="course_card_container">
                  <div class="course_card_left">
                    <div class="course_card course_main">
                      <div
                        class="course_left"
                        :class="[item.isknow ? 'warnShadow' : '']"
                      >
                        <div
                          v-if="item.ProtocolTypeList&&item.ProtocolTypeList.length === 1"
                          class="card_badge"
                          :title="item.ProtocolTypeList[0].Name"
                        >
                          <em>{{ item.ProtocolTypeList[0].Name }}</em>
                        </div>
                        <div
                          v-else-if="item.ProtocolTypeList&&item.ProtocolTypeList.length >= 2"
                          class="card_badge"
                          title="MIX"
                        >
                          <em>MIX</em>
                        </div>
                        <img
                          v-if="$store.state.isLocalServer"
                          class="card_img"
                          :src="getClassSkuImage(item,'on','../../assets/img/d_f1.png')"
                        >
                        <img
                          v-else
                          class="card_img"
                          :src="getImgUrlState(item, 'on')"
                        >
                      </div>
                      <div class="course_right">
                        <p
                          class="course_name"
                          :title="item.DeviceName"
                        >
                          {{ item.DeviceName }}
                        </P>
                        <p
                          class="course_block"
                          :title="item.ParentAreaNames"
                        >
                          {{ $t('sync.areaname') }}：{{ item.ParentAreaNames }}
                        </P>
                        <p
                          class="course_time"
                          :title="timeOffset(item.ConfigTime)"
                        >
                          {{ $t('sync.time') }}：{{ timeOffset(item.ConfigTime) }}
                        </P>
                      </div>
                      <!-- <el-button
                  v-if="item['Mac']!=null"
                  class="course_know de_course_know"
                  @click="Identification(item)"
                >
                  {{ $t('sync.identification') }}
                </el-button> -->
                      <div v-if="item['Mac']!=null" class="course_know de_course_know_v2">
                        <Distinguish
                          :msg="item"
                          :is-parent-flash="true"
                          @flash="flash"
                        />
                      </div>
                
                      <el-button
                        v-if="item.ChannelName"
                        class="operate_button"
                      >
                        {{ item.ChannelName }}
                      </el-button>
                    </div>
                    <div v-if="item.ResultCode === 4 && item.SceneName" class="course_card_bottom">
                      {{ $t('sync.manle').replace('$$', item.SceneName) }}
                    </div>
                  </div>
                  <div class="course_identify">
                    <div
                      v-if="item.ResultCode == 2"
                      class="state_faile"
                    >
                      <i class="icon-11" />
                      <div class="course_button">
                        <OppleButton
                          size="mini"
                          @click="retry(item)"
                        >
                          {{ $t('sync.retry') }}
                        </OppleButton>
                      </div>
                    </div>
                    <div
                      v-if="[0, 4].includes(item.ResultCode)"
                      class="state_faile"
                    >
                      <span 
                        v-if="item.ResultCode === 0"
                        style="display: block;margin-bottom: 16px;margin-top: 8px;"
                      >{{ $t('sync.synchronizing') }}</span>
                      <div class="course_button">
                        <OppleButton
                          size="mini"
                          @click="retry(item)"
                        >
                          {{ $t('sync.retry') }}
                        </OppleButton>
                      </div>
                    </div>
                    <i
                      v-show="item.ResultCode == 1"
                      class="state_sucess icon-5"
                    />
                  </div>
                </div>
              </div>
              <div>
                <!-- {{ item}} -->
              </div>
            </div>
          </div>
        </div>
      </vuescroll>
    </div>
    <div class="course_box clearfix">
      <OppleAuth
        v-if="panelType === 6"
        key="6"
        code="UpdateConfigDevice"
        :force-show="$store.state.isPassPermission"
      >
        <el-button
          v-intervalclick="{func:goingTry}"
          class="curse_go fleft"
        >
          {{ $t('sync.alltry') }}
        </el-button>
      </OppleAuth>
      <OppleAuth
        v-else-if="panelType === 2"
        key="2"
        code="EditScene"
        :force-show="$store.state.isPassPermission"
      >
        <el-button
          v-intervalclick="{func:goingTry}"
          class="curse_go fleft"
        >
          {{ $t('sync.alltry') }}
        </el-button>
      </OppleAuth>
      <OppleAuth
        v-else-if="[3, 4, 5].includes(panelType)"
        key="3"
        code="EditAuto"
        :force-show="$store.state.isPassPermission"
      >
        <el-button
          v-intervalclick="{func:goingTry}"
          class="curse_go fleft"
        >
          {{ $t('sync.alltry') }}
        </el-button>
      </OppleAuth>
      <el-button
        v-else
        key="99"
        v-intervalclick="{func:goingTry}"
        class="curse_go fleft"
      >
        {{ $t('sync.alltry') }}
      </el-button>
      <el-button
        class="curse_try fright"
        @click="backgroundDo"
      >
        {{ $t('sync.close') }}
      </el-button>
    </div>
    <template v-if="imgDialog">
      <!-- <el-dialog
        :modal-append-to-body="false"
        :title="$t('devicecard.dowarn')"
        :visible.sync="imgDialog"
        class="imgDialog"
        width="30%"
        append-to-body
        :before-close="handleClose"
      >
        <img
          class="Dialogimg"
          :src="imgsrc"
        >
        <div class="Dialogimg">
          {{ imgsrcDesc }}
        </div>
      </el-dialog> -->
      <el-dialog
        :modal-append-to-body="false"
        :title="$t('devicecard.dowarn')"
        :visible.sync="imgDialog"
        class="imgDialog"
        width="50%"
        :before-close="handleClose"
      >
        <template v-for="(item, index) in imgsrcDesc">
          <div :key="index">
            <img v-if="item.Type === 'img'" class="Dialogimg" :src="item.Value">
            <div v-if="item.Type === 'txt'" class="Dialogimg txt">
              {{ item.Value }}
            </div>
          </div>
        </template>
      </el-dialog>
    </template>
  </div>
</template>

<script>
//0-同步中 1-成功  2-失败 3- 默认
import vuescroll from 'vuescroll';
import { FindUnSyncCount, FindUnSyncList } from '@/axios/ISyncPanel.js';
import { FindDeviceSyncResult, GetIdentifyInfo, PositiveIdentify, ReSyncProjectCode, ReSyncSmartConfig,GetUIGuideDataList } from '@/axios/IDevice.js';
import { ShowHistorySyncResult, ReSyncAreaCode, ShowCurrentSyncResult } from '@/axios/IArea.js';
import { ShowIftttHistorySyncResult, ShowIftttCurrentSyncResult, ReSyncIftttDeviceConfig, ReSyncConstIlluminationConfig, ReSyncRhythmConfig } from '@/axios/IFttt.js';
import { ShowSceneHistorySyncResult, ShowSceneCurrentSyncResult, ReSyncDeviceConfig } from '@/axios/IScene.js';
import { alerterror, alertsuccess, warning, info } from '@/assets/js/common.js';
import { catchRequireErr, getImgUrlState } from '@/utils/utils'
import { postWebIOSocket } from '@assets/socket';
import { IDENTIFY_TYPE,CONFIGTYPE , APPTYPE} from '@/utils/enums'
import Distinguish from "@/components/button/Distinguish";
import OppleButton from '@/components/Base/OppleButton/index.vue'

export default {
  name: 'Course', //searchtype 1当前 2/历史 removecurrent当前面板的参数
  components: {
    vuescroll,
    Distinguish,
    OppleButton
  },
  props: ['courseid', 'areaTreeType', 'searchtype', 'removecurrent', 'isDeviece', 'gpno', 'deviceId'],
  data() {
    return {
      loadHistory: false, //是否加载
      courseHistory: [], //数据
      socketpara: {}, //socket对象
      pollingclock: null, //定时器 已取消
      totalTime: 130, //定时时间 已取消
      imgDialog: false, //是否弹出识别图片
      imgsrc: '', //识别图片
      imgsrcDesc: '',
      typeTranslate: {
        '0': this.$t('sync.area'),
        '1': this.$t('sync.scene'),
        '2': this.$t('sync.ifttt'),
        '4': this.$t('sync.config'),
        '5': this.$t('sync.projectId'),
        '10': this.$t('sync.constIllumination'),
        '9': this.$t('sync.rhythm')
      }, //描述
      isDoCardsetResresh: true, //是否可执行刷新
      ardsetResreshTotalTime: 1000, //执行刷新间隔5秒
      selectTypeList: [
        { name: this.$t('sync.config'), value: 6, isDeploy: false },
        { name: this.$t('sync.scene'), value: 2, isDeploy: false },
        { name: this.$t('sync.ifttt'), value: 3, isDeploy: false },
        { name: this.$t('sync.projectId'), value: 0, isDeploy: false },
        { name: this.$t('sync.constIllumination'), value: 4, isDeploy: false },
        { name: this.$t('sync.rhythm'), value: 5, isDeploy: false },
        { name: this.$t('sync.area'), value: 1, isDeploy: false },

      ],
      panelType: '',
    };
  },
  computed: {
    socketmodel() {
      return this.$store.state.socketmodel;　　//需要监听的数据
    },
  },
  watch: {
    socketmodel(rs, old) {
      //监听socket
      this.functionScoketsync_info_event(rs);
    },
    'courseHistory.length':function(rs,old){
      if(rs === old){
        this.loadHistory = false
      }
    }
  },
  mounted() {
    this.panelType = this.areaTreeType;
    //初始化加载数据
    this.isDoCardsetResresh = true;

    this.doShowHistorySyncResult();

  },
  destroyed() {
    //页面销毁 情况计时器
    this.clearIntervalTime();
  },
  methods: {
    getImgUrlState:getImgUrlState,
    functionDoFindUnSyncCount(rs) {
      this.selectTypeList.forEach(item => { item["isDeploy"] = false; });
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          var item = rs.Result;
          if (item["SmartConfigsCount"] != null && item["SmartConfigsCount"] > 0) { this.selectTypeList[0]["isDeploy"] = true; }
          if (item["SceneCount"] != null && item["SceneCount"] > 0) { this.selectTypeList[1]["isDeploy"] = true; }
          if (item["IFtttCount"] != null && item["IFtttCount"] > 0) { this.selectTypeList[2]["isDeploy"] = true; }
          if (item["ProjectCodeCount"] != null && item["ProjectCodeCount"] > 0) { this.selectTypeList[3]["isDeploy"] = true; }
          if (item["ConstantIlluminationCount"] != null && item["ConstantIlluminationCount"] > 0) { this.selectTypeList[4]["isDeploy"] = true; }
          if (item["RhythmSyncCount"] != null && item["RhythmSyncCount"] > 0) { this.selectTypeList[5]["isDeploy"] = true; }
          if (item["AreaCodeCount"] != null && item["AreaCodeCount"] > 0) { this.selectTypeList[6]["isDeploy"] = true; }
          item = null;
        }
      }
    },
    /* 关闭看板
    */
    close() {
      this.$emit('closeCourse');
    },
    /* 关闭看板
    */
    handleClose(done) {
      done();
      this.imgsrc = '';
      this.imgsrcDesc = '';
      //this.doFindDeviceListByPage();
    },
    /* 清空计时器
    */
    clearIntervalTime() {
      //清楚计时器
      clearInterval(this.pollingclock);
    },
    /* socket推送过来的数据处理
    * rs:推送原始数据包
    */
    functionScoketsync_info_event(rs) {

      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        var n, i = 0, l = this.courseHistory.length;
        if (rs.Result[0].Type == 3) {
          //被动识别
          this.imgDialog = false;
          this.courseHistory.forEach(n => {
            if (n.Mac == rs.Result[0].DeviceMac) {
              n.isknow = true;
              //socket.emit('sync_info_remove_event', { data: [{ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac }] });
              setTimeout(() => {
                n.isknow = false;
              }, 2000);
            }
          });
        } else if (rs.Result[0].Type == 19) {
          // console.log(rs);
          // console.log('场景同步返回');
          if (this.panelType == 2) {
            this.courseHistory.forEach(n => {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.SceneId == rs.Result[0].SceneId) {
                n.ResultCode = 1;
              }
            });
            // }else if(this.panelType == 6){
            //
            // 	for(;i<l;i++){
            // 		n = this.courseHistory[i];
            // 		if (n.TransType == 1 && n.VDeviceId == rs.Result[0].VDeviceId&&n.SourceId==rs.Result[0].SceneId) {
            // 			n.ResultCode=1;
            // 		}
            // 	}
          }
        } else if (rs.Result[0].Type == 20) {
          // console.log(rs);
          // console.log('自动化同步返回');
          if (this.panelType == 3) {
            this.courseHistory.forEach(n => {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.IFtttNo == rs.Result[0].IFtttNo) {
                n.ResultCode = 1;
              }
            });
            // }else if(this.panelType == 6){
            // 	for(;i<l;i++){
            // 		n = this.courseHistory[i];
            // 		if (n.TransType == 2 && n.VDeviceId == rs.Result[0].VDeviceId&&n.SourceId==rs.Result[0].IFtttNo) {
            // 			n.ResultCode=1;
            // 			break;
            // 		}
            // 	}
          }
          this.$emit('returncall');
        } else if (rs.Result[0].Type == 21) {
          // console.log(rs);
          // console.log('区域同步返回');
          if (this.panelType == 1) {
            this.courseHistory.forEach(n => {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.ChannelId == rs.Result[0].ChannelId && n.GpNo == rs.Result[0].GpNo) {
                n.ResultCode = 1;
              }
            });
            // }else if(this.panelType == 6){
            //   for(;i<l;i++){
            // 		n = this.courseHistory[i];
            // 		if (n.TransType == 0 && n.VDeviceId == rs.Result[0].VDeviceId&&n.ChannelId==rs.Result[0].ChannelId) {
            // 			n.ResultCode=1;
            // 			break;
            // 		}
            // 	}
          }
          this.$emit('returncall');
        } else if (rs.Result[0].Type == 23) {
          // console.log('配置同步返回');
          if (this.panelType == 6) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 4 && n.VDeviceId == rs.Result[0].VDeviceId && n.SourceId == rs.Result[0].CommandKey) {
                n.ResultCode = 1;
                break;
              }
            }
          }
        } else if (rs.Result[0].Type == 22) {
          // console.log('项目同步返回');
          if (this.panelType == 0) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              // if (n.TransType == 5 && n.VDeviceId == rs.Result[0].VDeviceId) {
              if (n.VDeviceId == rs.Result[0].VDeviceId) {
                n.ResultCode = 1;
                break;
              }
            }
          }
        } else if (rs.Result[0].Type == 17) {
          // console.log(rs);
          // console.log('恒照度同步返回');
          if (this.panelType == 4) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              // if (n.TransType == 10 && n.VDeviceId == rs.Result[0].VDeviceId&&n.SourceId==rs.Result[0].ConstantIlluminationId) {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.IFtttNo == rs.Result[0].ConstantIlluminationId) {
                n.ResultCode = 1;
                break;
              }
            }
          }
          this.$emit('returncall');
        } else if (rs.Result[0].Type == 18) {
          // console.log('节律同步返回');
          if (this.panelType == 5) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              // if (n.TransType == 9 && n.VDeviceId == rs.Result[0].VDeviceId&&n.SourceId==rs.Result[0].RhythmNo) {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.IFtttNo == rs.Result[0].RhythmNo) {
                n.ResultCode = 1;
                break;
              }
            }
          }
          this.$emit('returncall');
        }
        n = null;
        i = null;
        l = null;
      }
      this.$forceUpdate();//强制渲染
    },
    /* 设置计时器
    */
    doPolling() {
      this.pollingclock = window.setInterval(this.computeData, 1000);
    },
    /* 计时器计算
    */
    computeData() {
      this.totalTime--;
      if (this.totalTime <= 0) {
        this.totalTime = 130;
        this.clearIntervalTime();
      } else {
        this.courseHistory.forEach(n => {
          if (n.ResultCode == 0 && this.searchtype == 1) {
            var _nowtime = new Date();
            if (n.endTime < _nowtime) {
              n.ResultCode = 2;
            }
          }
        })
      }

    },
    /* 获得看板数据 处理数据格式
    * rs:接口返回的原始数据包
    */
    functionDoNotice(rs) {
      this.loadHistory = false;
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // console.log(rs);

        if (rs.Result != null && rs.Result.RecordList != null && rs.Result.RecordList.length > 0) {
          var paramac = { data: [] };
          var _arrmac = [];
          rs.Result.RecordList.forEach(n => {
            if (this.searchtype == 1) {
              var ishassclock = false;
              if (n.ResultCode == 0) {
                //console.log();
                var _time = new Date(n.ConfigTime.replace('T', ' '));
                _time.setMinutes(_time.getMinutes() + 1);

                n.endTime = _time;
                _time = null;
                ishassclock = true;
              }
              // if(ishassclock){
              // 	this.doPolling();
              // }
            }
            n.isknow = false;
            if (n.IsBind) {
              _arrmac.push({ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac });
            }

          });
          this.courseHistory = rs.Result.RecordList;
          paramac.data = _arrmac;
          if (paramac.data.length > 0) {
            //socket.emit('sync_info_add_event', paramac);
            postWebIOSocket('sync_info_add_event', paramac);
          }
          paramac = null;
          _arrmac = null;
        }
      }
      this.$emit('historycount', this.courseHistory.length);
    },
    doSocket(_list) {

    },
    /* 获取看板数据 searchtype为1 说明是同步看板 其他则是历史看板 根据areaTreeType 判断是区域1 场景2 自动化3 同时注册socket
    */
    doShowHistorySyncResult(param) {
      var _areaTreeType = this.panelType;
      if (param != null) {
        _areaTreeType = param;
        this.panelType = param;
      }
      this.courseHistory = [];
      // if (this.courseid != -1) { //&& this.courseid != 0
      this.socketpara.data = [];
      if (_areaTreeType == 1) {
        //区域
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 21, id: this.$store.state.projectcode });
      } else if (_areaTreeType == 2) {
        //场景
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 19, id: this.$store.state.projectcode });
      } else if (_areaTreeType == 3) {
        //自动化
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 20, id: this.$store.state.projectcode });
      } else if (_areaTreeType == 6) {
        //参数配置同步看板 （临时加了项目看版 areaTreeType=5)
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 23, id: this.$store.state.projectcode });
      } else if (_areaTreeType == 4) {
        //恒照度同步消息
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 17, id: this.$store.state.projectcode });
      } else if (_areaTreeType == 5) {
        //节律同步消息
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 18, id: this.$store.state.projectcode });
      } else if (_areaTreeType == 0) {
        //设备出入项目同步消息 项目号
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 22, id: this.$store.state.projectcode });
      }
      if (this.socketpara.data.length > 0) {
        postWebIOSocket('sync_info_add_event', this.socketpara);
      }

      this.loadHistory = true;
      var para = this.isDeviece ? { vDeviceId: this.courseid } : { gpNo: this.courseid };
      para["panelType"] = _areaTreeType;
      FindUnSyncList(para, this.functionDoNotice);
      FindUnSyncCount(para, this.functionDoFindUnSyncCount);
      para = null;
      // }
    },

    functionDoReSyncAreaCode(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    /* 点击区域重试
    * item 设备对象
    * isParam：
    */
    doReSyncAreaCode(item, isParam) {
      //区域重试
      var para = { gpNo: item.GpNo, vDeviceId: item.VDeviceId, channelId: item.ChannelId };
      ReSyncAreaCode(isParam ? item : para, this.functionDoReSyncAreaCode);
      item.ResultCode = 0;
      para = null;
    },
    /* 点击场景重试
    * item 设备对象
    * isParam：
    */
    doReSyncDeviceConfig(item, isParam) {//场景
      var para = { sceneNo: item.SceneId, vDeviceId: item.VDeviceId, channelId: item.ChannelId };
      ReSyncDeviceConfig(isParam ? item : para, this.functionDoReSyncDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    /* 点击ifttt重试
    * item 设备对象
    * isParam：
    */
    doReSyncIftttDeviceConfig(item, isParam) {
      var para = { iftttNo: item.IFtttNo, vDeviceId: item.VDeviceId, executeType: item.ExecuteType };
      ReSyncIftttDeviceConfig(isParam ? item : para, this.functionDoReSyncIftttDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncConstIlluminationConfig(item, isParam) {
      var para = { constIlluminationNo: item.constIlluminationNo, vDeviceId: item.VDeviceId, executeType: item.ExecuteType };
      ReSyncConstIlluminationConfig(isParam ? item : para, this.functionDoReSyncIftttDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncRhythmConfig(item, isParam) {
      var para = { rhythmNo: item.rhythmNo, vDeviceId: item.VDeviceId, executeType: item.ExecuteType };
      ReSyncRhythmConfig(isParam ? item : para, this.functionDoReSyncIftttDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncProjectCode(item, isParam) {
      //区域重试
      var para = { vDeviceId: item.VDeviceId };
      ReSyncProjectCode(isParam ? item : para, this.functionDoReSyncProjectCode);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncSmartConfig(item, isParam) {
      //参数重试

      var para = { commandKey: item.SourceId, vDeviceId: item.VDeviceId };
      ReSyncSmartConfig(isParam ? item : para, this.functionDoReSyncProjectCode);
      item.ResultCode = 0;
      para = null;
    },

    functionDoReSyncDeviceConfig(rs) {
      //console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    functionDoReSyncIftttDeviceConfig(rs) {
      // console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    functionDoReSyncProjectCode(rs) {
      // console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    retry(item, isNoTitle) {
      //重试

      if (item.ResultCode == 0 && isNoTitle != true) {
        warning(this, this.$t('sync.retry') + '-' + this.$t('sync.synchronizing'));
      }

      if (this.panelType == 0) {//project
        this.doReSyncProjectCode({ "vDeviceId": item["VDeviceId"] }, true);
      } else if (this.panelType == 1) {//area
        this.doReSyncAreaCode(item);
      } else if (this.panelType == 2) {//scene
        this.doReSyncDeviceConfig(item);
      } else if (this.panelType == 3) {//ifttt
        this.doReSyncIftttDeviceConfig(item);
      } else if (this.panelType == 4) {//project
        this.doReSyncConstIlluminationConfig({ "constIlluminationNo": item["IFtttNo"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
      } else if (this.panelType == 5) {
        this.doReSyncRhythmConfig({ "rhythmNo": item["IFtttNo"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
      } else if (this.panelType == 6) {
        //this.doReSyncIftttDeviceConfig(item);
        if (item["TransType"] == 0) {//area
          item.ResultCode = 0;
          this.doReSyncAreaCode({ "gpNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "channelId": item["ChannelId"] }, true);
        } else if (item["TransType"] == 1) {//scene
          item.ResultCode = 0;
          this.doReSyncDeviceConfig({ "sceneNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "channelId": item["ChannelId"] }, true);
        } else if (item["TransType"] == 2) {//ifttt
          item.ResultCode = 0;
          this.doReSyncIftttDeviceConfig({ "iftttNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
        } else if (item["TransType"] == 4) {//deviceConfig
          item.ResultCode = 0;
          this.doReSyncSmartConfig({ "commandKey": item["SourceId"], "vDeviceId": item["VDeviceId"] }, true);
        } else if (item["TransType"] == 5) {//project
          item.ResultCode = 0;
          this.doReSyncProjectCode({ "vDeviceId": item["VDeviceId"] }, true);
        } else if (item["TransType"] == 10) {//constIllumination 恒照度
          item.ResultCode = 0;
          this.doReSyncConstIlluminationConfig({ "constIlluminationNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
        } else if (item["TransType"] == 9) {//rhythm 节律
          item.ResultCode = 0;
          this.doReSyncRhythmConfig({ "rhythmNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
        }
      }
    },
    // delSync(item) {
    //删除
    // console.log('删除');
    // },
    /* 识别接收的方法 实现卡片闪动
    * rs 接口返回原始数据包
    * para：接口的参数
    * model：设备对象
    */
    functionDoPositiveIdentify(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        model.isknow = true;
        setTimeout(() => {
          model.isknow = false;
        }, 2000);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    //识别
    flash(model){
      model.isknow = true;
        setTimeout(() => {
          model.isknow = false;
        }, 2000);
    },
    /* 对主动识别跟被动识别的处理 主动下发指令
    * rs 接口返回原始数据包
    * model：设备对象
    */
    doPositiveIdentify(result, model) {
      if (result.IdentifyType == 1 || result.IdentifyType == 2) {
        //被动识别
        this.dosocket(model);
        console.log(model);
        var _imgurl = '';
        if (model.ClassSku == "0x02000308") {
          _imgurl = require("@static/device/identify/nonev2.png");
        } else if (result.IntroImage == '' || result.IntroImage == null || result.IntroImage.indexOf('http') != -1) {
          _imgurl = require('@static/device/identify/none.png');
        } else {
          _imgurl = catchRequireErr(() => require('@static/device/identify/' + result.IntroImage));
        }
        this.imgsrc = _imgurl;
        this.imgsrcDesc = result["IntroDesc"] || '';
        this.imgDialog = true;
        _imgurl = null;
      } else {

        var para = { mac: model.Mac, deviceId: model.VDeviceId, channelId: model.ChannelId };
        PositiveIdentify(para, this.functionDoPositiveIdentify, model);
        para = null;
      }
    },
    /* 获得设备的识别方式 接口返回的数据处理
    * rs 接口返回原始数据包
    * para：提交的参数
    * model：设备对象
    */
    functionDoGetIdentifyInfo(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //去识别

        this.doPositiveIdentify(rs.Result, model);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 获得设备的识别方式
    * model：设备对象
    */
    doGetIdentifyInfo(model) {
      // logOutUser
      //查询设备认领方式
      // console.log(model);
      var para = { classSku: model.ClassSku, channelId: model.ChannelId };
      GetIdentifyInfo(para, this.functionDoGetIdentifyInfo, model);
      para = null;
    },
    /* 点击页面识别按钮
    * item：设备对象
    */
    Identification(item) {
      //点击识别
      // console.log('识别');
      // this.imgDialog=true;
      this.doGetIdentifyInfo(item);
    },
    /* 点击后台执行
    */
    backgroundDo() {
      debugger
      this.$emit('backgroundDo');
    },
    /* 点击全部重试
    */
    goingTry() {
      console.log('this.panelType', this.panelType);
      
      debugger
      if (this.courseHistory.length > 0) {
        // warning(this, this.$t('sync.retry') + '-' + this.$t('sync.synchronizing'));
        this.courseHistory.forEach(item => {
          if (item.ResultCode != 1) {
            //2失败 0同步中 1成功
            //if(item.ResultCode==2){
            //失败的重试
            this.retry(item, true);
            // if (this.areaTreeType == 1) {
            // 	this.doReSyncAreaCode(item);
            // } else if (this.areaTreeType == 2) {
            // 	this.doReSyncDeviceConfig(item);
            // } else if (this.areaTreeType == 3) {
            // 	this.doReSyncIftttDeviceConfig(item);
            // }
          }

        });
      }
      //this.$emit('alltry',this.courseHistory);
    },
    cardsetResresh() {
      if (!this.isDoCardsetResresh) { return; }
      this.isDoCardsetResresh = false;
      let ardsetResreshTotalClock = window.setInterval(() => {
        this.ardsetResreshTotalTime--;
        if (this.ardsetResreshTotalTime < 0) {
          window.clearInterval(ardsetResreshTotalClock);
          this.ardsetResreshTotalTime = 1000;
          this.isDoCardsetResresh = true;
        }
      });
      this.doShowHistorySyncResult();
    }
  }
};
</script>

<style lang="scss" scoped>
/* 数据同步面板组件	 */
.cousre_header {
  color: #202020;
  em {
    font-style: normal;
    color: #4f8ee7;
  }
}
.card_img{
  height: 55px;
}
.de_course_know_v2 ::v-deep .el-button {
  width: 100%;
  padding: 0px;
  height: 100%;
}
.de_course_know_v2 >div {
  width: 100%;
  height: 100%;
}
.de_course_know_v2 ::v-deep .el-dialog .el-dialog__header{
  display: block;
}
.de_course_know_v2 ::v-deep .el-dialog .el-dialog__header  .el-icon-close{
  padding: 0px;
}
.de_course_know_v2 ::v-deep .el-dialog .el-dialog__body{
  padding: 10px 20px 30px !important;
}
.course_container {
  display: flex;
}

.course_card.course_main {
  width: 100%;
}
.course_identify {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-left: 10px;
}
.cousreing_next .course_know.de_course_know_v2 {
  width: auto;
}

.de_course_know_v2 ::v-deep .el-dialog {
  margin-top: auto !important;
}
.course_card_container {
  display: flex;
  width: 100%;
}
.course_card_left {
  border: 1px solid #eee;
  border-radius: 4px;
  width: 80%;
}
.course_card_bottom {
  padding: 6px;
}
</style>
